import { useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";

const Help = (pageProps: PageProps) => {
  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  return (
    <MainCard title={pageProps.appUtil.getLocaleString("help")}>
      <div>
        Please contact our support team at{" "}
        <a href="mailto:support@art-digit.com">support@art-digit.com</a> for assistance.
      </div>
    </MainCard>
  );
};

export default Help;
